export default "__VITE_ASSET__DUVZFBzc__"